import { useMemo, useState } from "react";

import dayjs from "@/lib/dayjs";

import { FeatureIslandHeader } from "@/components/features/_layouts";

import { Label } from "@/components/ui/label/label";

import { PlanRateMatrixApiSection } from "./api-section";
import { PlanRateMatrixBetaNotice } from "./beta-notice";
import { getMonthDates } from "../../model/get-month-date-range";

type Props = {
	hotelID: string;
};

/**
 * 日別料金一覧はプラン一覧／在庫のタブ構成（一覧・日ごとの在庫管理）とは無関係なため、
 * PlanHeaderAndTabs ではなくタブなしの FeatureIslandHeader を使う。
 * ベータ提供中のため、見出しと FB 導線でその旨を明示する。
 */
export const PlanRateMatrix = ({ hotelID }: Props) => {
	const [yearMonth, setYearMonth] = useState(dayjs().format("YYYY-MM"));
	const dates = useMemo(() => getMonthDates(yearMonth), [yearMonth]);

	return (
		<>
			<FeatureIslandHeader
				title="料金一覧"
				titleRightChildren={<Label text="ベータ" variant="black" size="xs" />}
			/>

			<PlanRateMatrixBetaNotice hotelID={hotelID} />

			{/* Suspense は api-section 内の料金テーブル領域のみ。操作UIは維持する */}
			<PlanRateMatrixApiSection
				hotelID={hotelID}
				yearMonth={yearMonth}
				dates={dates}
				onChangeYearMonth={setYearMonth}
			/>
		</>
	);
};

PlanRateMatrix.displayName = "PlanRateMatrix";
